
import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PlusUpView from 'components/guide/PlusUpView';
import * as guideActions from 'store/modules/guide';
import * as util from 'store/modules/utils';

class PlusUpContainer extends Component {

  onChangePlusFilter = (e) => {
    const {GuideActions} = this.props;
    const {name, value} = e.target;

    GuideActions.setPlusOpt({name, value});
  }

  ctrlReCalc = () => {
    const {GuideActions} = this.props;
    GuideActions.reCalc();
  }

  render() {
    const {onChangePlusFilter, ctrlReCalc} = this;
    const {plsuUpNoti} = this.props;
    const plusUpGrid = util.calcPlusUpGrid();
    const plusUpLuck = util.calcPlusUpLuck();
    const plusUpRandom = util.getRandom;
    
    return (
      <PlusUpView
        plusUpGrid={plusUpGrid}
        onChangePlusFilter={onChangePlusFilter}
        plsuUpNoti={plsuUpNoti}
        plusUpLuck={plusUpLuck}
        plusUpRandom={plusUpRandom}
        ctrlReCalc={ctrlReCalc}
      />
    );
  }
}

export default connect(
  (state) => ({
    plsuUpNoti: state.guide.toJS().plsuUpNoti
  }),
  (dispatch) => ({
    GuideActions: bindActionCreators(guideActions, dispatch)
  })
)(PlusUpContainer);